import { cn } from '@savvy-kit/lib/utils';

type GlyphsProps = {
  readonly text: string;
  readonly className?: string;
};

// Each glyph is CSS generated content off `data-glyph`, not a text node: the whole figure lives once in an
// `sr-only` sibling, so assistive tech, copy and text queries meet it exactly once and never a stray "8".
const GLYPH_CLASS = 'inline-block before:content-[attr(data-glyph)]';

function glyphOf(char: string): string {
  return char === ' ' ? ' ' : char;
}

/** A figure drawn one character per span, so the characters can be moved independently. */
function Glyphs({ text, className }: GlyphsProps) {
  return (
    <span aria-hidden className={cn('inline-flex', className)}>
      {Array.from(text).map((char, index) => (
        <span key={`${index}-${char}`} aria-hidden data-glyph={glyphOf(char)} className={GLYPH_CLASS} />
      ))}
    </span>
  );
}

export { GLYPH_CLASS, Glyphs, glyphOf };
